import Angular from "angular";
import Settings from "../providers/settings.provider";

let AuthenticationInterceptorModule = Angular.module('AuthenticationInterceptor', [Settings.name]);

AuthenticationInterceptorModule.factory('AuthenticationInterceptor', ['$q', '$location', 'settings', function ($q, $location, settings) {
    return {
        request: (config) => {
            config.headers['x-neo-jwt'] = settings.user.token;
            return config || $q.when(config);
        },

        responseError: (rejection) => {
            if (rejection.status == 403) {
                $location.url('/login');
            }

            return $q.reject(rejection);
        }
    }

}]);

export default AuthenticationInterceptorModule;



// WEBPACK FOOTER //
// ./src/modules/main/interceptors/authentication.interceptor.js